__turbopack_context__.v({
  "className": "caveat_9a97a476-module__gXYNEq__className",
});
